import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

function RadioGroup({
  className,
  children,
  value,
  onChangeValue,
  compact,
  label,
  ...props
}) {
  const renderChildren = () => Children.map(children, (child) => {
    const { value: childValue } = child.props;

    return cloneElement(child, {
      checked: childValue === value,
      key: childValue,
      onClick: () => onChangeValue(childValue),
    });
  });

  return (
    <div
      className={(compact ? 'RadioGroup--compact ' : '') + (className || '')}
      {...props}
    >
      {
        label && <div className="RadioGroup__label">Luft</div>
      }
      {renderChildren()}
    </div>
  );
}

RadioGroup.propTypes = {
  value: PropTypes.any.isRequired,
  onChangeValue: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
};

export default RadioGroup;

export { default as Radio } from './Radio';
